







import { genVuexComputeds } from '@/main/pages/editFactory';
import { Doklad } from '@/modules/servis/doklad';
import { OperationFlags } from '@/main/components/dms/common/operationFlagsConstants';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';

import { store } from '../../store/edit';
import { NAME } from './constants';

export default EditStoreMixin.extend({
	name: 'DokladyOstatni',
	data() {
		return {
			NAME,
			servisniDoklady: Doklad.name,
			extraOperationsAloved: OperationFlags.PROCESS,
		};
	},
	computed: {
		...genVuexComputeds(store),
	},
});
